import {
  acceptedFileTypes,
  getFileExt,
} from '../../../../constants/acceptedFileTypes';
import componentType from '../../utility/componentType';

const ALL_FILES_MAX_SIZE_IN_BYTES = 25 * 1024 * 1024;

export const checkValidFileType = (file, fileTypes) => {
  const ext = getFileExt(file);

  if (!fileTypes[ext]) {
    return false;
  }
  return true;
};
export const addNewFiles = (
  newFiles,
  filesSize,
  maxFileSizeInBytes,
  component,
) => {
  let allFilesSize = filesSize ?? 0;
  let error = {};
  const validFiles = {};
  if (newFiles) {
    Array.from(newFiles).forEach((file) => {
      if (
        allFilesSize + file?.size <= ALL_FILES_MAX_SIZE_IN_BYTES &&
        file?.size <= maxFileSizeInBytes
      ) {
        const isValidFileType = checkValidFileType(file, acceptedFileTypes);
        if (isValidFileType) {
          allFilesSize += file?.size;
          if (component === componentType.TASKBOARD_POPUP) {
            validFiles[file?.name] = file;
            allFilesSize =
              allFilesSize - validFiles[file?.name]?.size + file?.size;
          } else {
            validFiles[file?.name] = { File: file };
            allFilesSize =
              allFilesSize - validFiles[file?.name]?.File?.size + file?.size;
          }
        } else {
          error = { ...error, fileTypeError: true };
        }
      } else {
        error = { ...error, fileSizeError: true };
      }
    });
  }
  return {
    validFiles: { ...validFiles },
    allFilesSize,
    errors: { ...error },
  };
};
